<template>
  <div class="coupon-detail-modal-mask" v-if="visible">
    <div class="coupon-detail-modal">
      <img :src="CloseIcon" alt class="coupon-detail-close" @click="handleClose" />
      <div class="coupon-detail-modal-header">{{detail.title}}</div>
      <div class="coupon-detail-modal-body">
        <template v-if="detail.type !== 4">
          <div class="coupon-body-title">
            <span class="coupon-body-title-circle"></span>
            <span class="coupon-body-title-text">使用门槛</span>
          </div>
          <div
            class="coupon-body-explain"
          >{{detail.decimalMinPoint=== 0 ? '无使用门槛': `满${detail.decimalMinPoint}元使用`}}</div>
          <div class="coupon-body-title">
            <span class="coupon-body-title-circle"></span>
            <span class="coupon-body-title-text">商品范围</span>
          </div>
          <div class="coupon-body-explain" v-if="scopeType === 'ALL_USABLE'">{{detail.goodsScopeStr}}</div>
          <div class="coupon-body-explain" v-if="scopeType === 'LOCAL_USABLE'">
            <div>以下指定商品可用</div>
            <div>课程：{{courseListStr}}</div>
          </div>
          <div class="coupon-body-explain" v-if="scopeType === 'LOCAL_FORBIDDEN'">
            <div>以下指定商品不可用</div>
            <div>课程：{{courseListStr}}</div>
          </div>
        </template>
        <div class="coupon-body-title">
          <span class="coupon-body-title-circle"></span>
          <span class="coupon-body-title-text">优惠券说明</span>
        </div>
        <div class="coupon-body-explain" v-html="detail.description"></div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "@/images/close.png";
import CouponUseRangeEnum from "@/enum/CouponUseRangeEnum";

export default {
  props: {
    visible: false,
    detail: {}
  },
  data() {
    return {
      CloseIcon,
      CouponUseRangeEnum,
      scopeType: "",
      courseListStr: ""
    };
  },

  watch: {
    detail() {
      this.getCouponDetail();
    }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },

    getCouponDetail() {
      const param = {
        couponId: this.detail.couponId
      };
      axios.Customer('public/coupon/getInstCouponDetail', param).then(res => {
        this.scopeType = res.result.scopeType;
        if (res.result.goodsNameList) {
          this.courseListStr = res.result.goodsNameList.join('，');
        }
      })
    }
  }
};
</script>

<style lang="less">
.coupon-detail-modal-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1111;
  .coupon-detail-modal {
    width: 5.4rem;
    height: 6.4rem;
    border-radius: 0.24rem;
    background-color: #fff;
    margin: 0 auto;
    margin-top: 2.2rem;
    position: relative;
    padding-top: 0.32rem;
    .coupon-detail-close {
      width: 0.24rem;
      height: 0.24rem;
      position: absolute;
      top: 0.3rem;
      right: 0.3rem;
    }
    .coupon-detail-modal-header {
      font-size: 0.34rem;
      color: #333;
      font-weight: 500;
      height: 0.34rem;
      line-height: 0.34rem;
      text-align: center;
      margin-bottom: 0.32rem;
    }
    .coupon-detail-modal-body {
      height: 5rem;
      overflow: auto;
      text-align: left;
      padding: 0 0.32rem;
      .coupon-body-title {
        font-size: 0.3rem;
        color: #333;
        display: flex;
        align-items: center;
        margin-bottom: 0.16rem;
        .coupon-body-title-circle {
          width: 0.12rem;
          height: 0.12rem;
          display: inline-block;
          border-radius: 50%;
          background: #666;
          margin-right: 0.08rem;
        }
        .coupon-body-title-text {
        }
      }
      .coupon-body-explain {
        color: #999;
        margin-bottom: 0.32rem;
        word-break: break-all;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/module/benefits/CouponDetailModal.vue